import { render, staticRenderFns } from "./ApiToken.vue?vue&type=template&id=3b2465fd&scoped=true&"
import script from "./ApiToken.vue?vue&type=script&lang=js&"
export * from "./ApiToken.vue?vue&type=script&lang=js&"
import style0 from "./ApiToken.vue?vue&type=style&index=0&id=3b2465fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2465fd",
  null
  
)

export default component.exports